import { render, staticRenderFns } from "./deptRetreatAddDialog.vue?vue&type=template&id=21436757&scoped=true"
import script from "./deptRetreatAddDialog.vue?vue&type=script&lang=js"
export * from "./deptRetreatAddDialog.vue?vue&type=script&lang=js"
import style0 from "./deptRetreatAddDialog.vue?vue&type=style&index=0&id=21436757&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21436757",
  null
  
)

export default component.exports